<template>
  <div class="services-sidebar-country">
    <div class="services-sidebar-country__item">
      <div class="animated-background --image"></div>
      <div class="--name">
        <div class="country-empty animated-background"></div>
      </div>
      <div v-if="type === 'country'">
        <div class="btn-empty animated-background mb-2 w-100"></div>
        <div class="d-flex">
          <div class="count-price-empty animated-background --info"></div>
          <div class="btn-empty animated-background --button btn-w-77"></div>
        </div>
      </div>
      <div v-else>
        <div class="count-price-empty animated-background --info"></div>
        <div class="btn-empty animated-background --button btn-w-77"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'country',
      validator: value => ['country', 'mail'].includes(value)
    }
  }
}
</script>
<style scoped></style>
